module.exports = __webpack_public_path__ + "img/E_SDG_Icons-05.5229ae5e.jpg";